import React from "react";
import { withRouter } from "react-router-dom";
import './signup.scss';
import fire from '../../../config/firebase';
import queryString from 'query-string'

class signupForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.signup = this.signup.bind(this);
    this.state = {
      email: '',
      password: '',
      errors: []
    };
    this.checkPassword = this.checkPassword.bind(this);
  }
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  checkPassword(pass) {
    const errors = [];
    const isNonWhiteSpace = /^\S*$/;
    if (!isNonWhiteSpace.test(pass)) {
      errors.push("Password must not contain Whitespaces.");
    }

    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    if (!isContainsUppercase.test(pass)) {
      errors.push("Password must have at least one Uppercase Character.");
    }

    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    if (!isContainsLowercase.test(pass)) {
      errors.push("Password must have at least one Lowercase Character.");
    }

    const isContainsNumber = /^(?=.*[0-9]).*$/;
    if (!isContainsNumber.test(pass)) {
      errors.push("Password must contain at least one Digit.");
    }

    const isContainsSymbol =
      /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
    if (!isContainsSymbol.test(pass)) {
      errors.push("Password must contain at least one Special Symbol.");
    }

    const isValidLength = /^.{8,16}$/;
    if (!isValidLength.test(pass)) {
      errors.push("Password must be 8-16 Characters Long.");
    }
    debugger;
    this.setState({ errors });
    return errors.length === 0;

  }
  signup(e) {
    e.preventDefault();

    if (this.checkPassword(this.state.password) === false) {
      return false;
    }
    const { email, logintoken } = queryString.parse(this.props.location.search);
    if (email && logintoken) {
      fire.auth().signInWithEmailAndPassword(email, logintoken).then(({ user }) => {
        user.updatePassword(this.state.password).then((res) => {
          window.location.pathname = '/dashboard';
        }).catch((e) => {

        });
      }).catch((err) => {

      });
    }

  }

  render() {
    const { email, logintoken } = queryString.parse(this.props.location.search);
    return (
      <section className="section no-pad-bot">
        <br />
        <div className="container">
          <h1 className="header center teal-text text-lighten-2">User Sign Up</h1>
          <div className="row">
            <form id="signup-form" className="col s12">
              <div className="row">
                <div className="input-field col s12">
                  <input value={email} onChange={this.handleChange} id="email" type="email" placeholder="Email" className="validate" name="email" v-model="email" />
                </div>
              </div>
              <div className="row">
                <div className="input-field col s12">
                  <input value={this.state.password} id="password" onChange={this.handleChange} type="password" placeholder="Create Password" className="validate" name="password" v-model="password" />
                </div>
                {
                  this.state.errors.length > 0 ? <ul>
                    {
                      this.state.errors.map((msg, index) => {
                        return <li key={index}>{msg}</li>
                      })
                    }
                  </ul> : null}
                <div className="input-field col s12">

                </div>
              </div>
              <div className="btn-row">
                <button onClick={this.signup} className="btn waves-effect waves-light" name="action">Submit
                </button>
              </div>
            </form>
          </div>
          <br />
        </div>
      </section>
    )
  }
}

export default withRouter(signupForm);
